import { DatePicker } from "source/shared/components"
import { Select } from "@planningcenter/doxy-web"
import { StatusOptions } from "../utils/frequency"
import { RecurringDonationStatus } from "../types"

interface EditStatusProps {
  status: RecurringDonationStatus
  releaseHoldAt: string | null
  onChangeStatus: (
    status: RecurringDonationStatus,
    releaseHoldAt: string | null,
  ) => void
  onChangeReleaseHoldAt: (releaseHoldAt: string | null) => void
}

export default function EditStatus({
  status,
  releaseHoldAt,
  onChangeStatus,
  onChangeReleaseHoldAt,
}: EditStatusProps) {
  const getTomorrow = (): Date => {
    const tomorrow = new Date()
    tomorrow.setDate(tomorrow.getDate() + 1)
    return tomorrow
  }

  const releaseHoldAtDate = releaseHoldAt ? releaseHoldAt : getTomorrow()

  const handleStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChangeStatus(event.target.value as RecurringDonationStatus, releaseHoldAt)
  }

  const handleReleaseHoldAtChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    onChangeReleaseHoldAt(event.target.value)
  }

  return (
    <div className="d-f@md ai-fe f_1">
      <div>
        <label htmlFor="status_select">Status</label>
        <Select value={status} id="status_select" onChange={handleStatusChange}>
          {StatusOptions.map((option, index) => (
            <Select.Option
              key={index}
              value={option.value}
              label={option.label}
            />
          ))}
        </Select>
      </div>
      {status === "hold_until" && (
        <div className="pl-2@md pt-1 pt-0@md">
          <DatePicker
            errorClass=""
            value={releaseHoldAtDate}
            minDate={getTomorrow()}
            onChange={(e) =>
              handleReleaseHoldAtChange(
                e as React.ChangeEvent<HTMLInputElement>,
              )
            }
            showYearDropdown={true}
            aria-label="select date"
            maxCap={2}
            minCap={0}
          />
        </div>
      )}
    </div>
  )
}
